import { Route } from '../../route.model';
import Locations from '@/views/Portal/Locations.vue';

const portalLocations = new Route(
  '/portal/locations',
  'portal-locations',
  Locations,
  {
    requiresAuth: true,
    isResponsive: true,
    zendesk: {
      disabled: true
    }
  }
);

export { portalLocations };
export default portalLocations;
